export { default as InputFileTemplate } from "./InputFileTemplate";
